"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_AVAILABLE = void 0;
exports.NOT_AVAILABLE = 'N/A';
const valueOrNA = (value) => {
    if (value === undefined || value === null || value === '') {
        return exports.NOT_AVAILABLE;
    }
    return value;
};
exports.default = valueOrNA;
